import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledHalfmoon: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_halfmoon"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="halfmoon icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 15 16"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M13.5896 11.9625C11.3857 15.7799 6.50446 17.0878 2.6871 14.8838C1.64753 14.2837 0.772387 13.4717 0.105836 12.5038C-0.117018 12.1802 0.0271368 11.7332 0.397078 11.6008C3.40348 10.5248 5.01368 9.27785 5.94805 7.49426C6.93172 5.61658 7.18592 3.55977 6.49779 0.740442C6.40264 0.350591 6.71057 -0.0206085 7.11128 0.000890588C8.35374 0.0675498 9.56756 0.424449 10.6683 1.05997C14.4857 3.26392 15.7936 8.14516 13.5896 11.9625Z" />
      </svg>
    </span>
  );
};

export { FilledHalfmoon };
